<template>
    <BaseCollapsible v-if="shouldShowNadiaIntelligence(message)" :open="isNadiaIntelligenceOpen(message.chat_message_id)">
        <template #content>
            <div class="mt-1 flex flex-col gap-2 border-t p-2">
                <div v-if="insightActions.length > 0" class="flex flex-col gap-1 px-1">
                    <ChatInlineInsightAccordion v-for="action in insightActions" :key="action.lineIdx" :data="action.line" />
                </div>
                <div v-if="connectionChatMessageActions.length > 0" class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <template v-for="action in connectionChatMessageActions" :key="action.lineIdx">
                        <ChatMyPeopleAccordion :connection-chat-message-action="action" :execute="execute" />
                    </template>
                </div>
                <ChatCollaborationSources v-if="collaborationSources.length > 0" :citations="collaborationSources" />
            </div>
        </template>
    </BaseCollapsible>
</template>

<script setup lang="ts">
import { ChatAction, pluckMultipleActions } from "~vue/chatActions";
import BaseCollapsible from "~vue/components/BaseCollapsible.vue";
import { useActionHandler } from "~vue/composables/useActionHandler";
import { useNadiaIntelligence } from "~vue/composables/useNadiaIntelligence";
import type { ChatMessage } from "~vue/types/chat";
import { computed } from "vue";

import ChatCollaborationSources from "./ChatCollaborationSources.vue";
import ChatInlineInsightAccordion from "./ChatInlineInsightAccordion.vue";
import ChatMyPeopleAccordion from "./ChatMyPeopleAccordion.vue";

type ChatNadiaIntelligenceProps = {
    message: ChatMessage;
};

const { message } = defineProps<ChatNadiaIntelligenceProps>();

const connectionChatMessageActions = computed(() => pluckMultipleActions([message], [ChatAction.TAGGED_PERSON]));
const insightActions = computed(() => pluckMultipleActions([message], [ChatAction.INTERNAL_THINKING, ChatAction.VALUES_INSIGHT]));
const collaborationSourceActions = computed(() => pluckMultipleActions([message], [ChatAction.WORKIQ_COLLABORATION_SOURCES]));
const collaborationSources = computed(() => collaborationSourceActions.value.flatMap((action) => action.line.action_params.sources));

const { execute } = useActionHandler();

const { isNadiaIntelligenceOpen, shouldShowNadiaIntelligence } = useNadiaIntelligence();
</script>
